import { defineStore } from 'pinia'

/**
 * 工程打开/创建、资源导入等阻塞任务的全局加载进度（与 `ProjectLoadOverlay` 配合）。
 */
export const useProjectLoadingStore = defineStore('projectLoading', {
  state: () => ({
    active: false,
    progress: 0,
    status: '',
    mode: 'overlay' as 'overlay' | 'inline',
  }),
  actions: {
    begin(status = '加载中…', mode: 'overlay' | 'inline' = 'overlay') {
      this.active = true
      this.progress = 0
      this.status = status
      this.mode = mode
    },
    set(progress: number, status?: string) {
      this.progress = Math.min(100, Math.max(0, Math.round(progress)))
      if (status !== undefined) this.status = status
    },
    /** 成功结束：进度拉满后短暂停留再关闭 */
    complete() {
      this.progress = 100
      this.status = '完成'
      window.setTimeout(() => {
        this.active = false
        this.progress = 0
        this.status = ''
        this.mode = 'overlay'
      }, 80)
    },
    /** 失败或取消：立即关闭 */
    fail() {
      this.active = false
      this.progress = 0
      this.status = ''
      this.mode = 'overlay'
    },
  },
})
